import { render, staticRenderFns } from "./PurchaseRequests.vue?vue&type=template&id=0f42ebcd"
import script from "./PurchaseRequests.vue?vue&type=script&lang=js"
export * from "./PurchaseRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports